// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import $ from 'jquery'
import Vue from 'vue'
import router from './router'
import ElementUI from 'element-ui'
import VTooltip from 'v-tooltip'
import importJs from './script/importJs.js'
import { getStore, setStore, isInRole, clearUserInStore, generateVisitorId, getBrowserBrandName } from "./config/mUtils";
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css';
import './style/v-tooltip.scss';
import './style/speedup.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min'
import 'font-awesome/css/font-awesome.min.css'
import './assets/iconfont.css'
import App from './App'
import 'whatwg-fetch';
//import './style/navigator.css'
import VideoPlayer from 'vue-video-player'

import JSExtender from '@/core/js-extender'
Vue.use(JSExtender)

import VueRefStore from 'vue-ref-store'
Vue.use(VueRefStore)

import QuestionnaireUI from '@/core/questionnaire-ui'
Vue.use(QuestionnaireUI)

import VueExtender from '@/core/vue-extender'
Vue.use(VueExtender)

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
//Vue.config.performance = true; 启用插件
Vue.config.productionTip = false;
window.Promise = Promise;
window.fetch = fetch;

import * as globalFilters from './filters/global'
Object.keys(globalFilters).forEach(key => {
  Vue.filter(key, globalFilters[key])
})

Date.prototype.format = function(fmt) {
  var o = {
     "M+" : this.getMonth()+1,                 //月份
     "d+" : this.getDate(),                    //日
     "h+" : this.getHours(),                   //小时
     "m+" : this.getMinutes(),                 //分
     "s+" : this.getSeconds(),                 //秒
     "q+" : Math.floor((this.getMonth()+3)/3), //季度
     "S"  : this.getMilliseconds()             //毫秒
 };
 if(/(y+)/.test(fmt)) {
         fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
 }
  for(var k in o) {
     if(new RegExp("("+ k +")").test(fmt)){
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
      }
  }
 return fmt;
}

Vue.use(VideoPlayer)
Vue.use(ElementUI)
Vue.use(VTooltip)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  created() {
    let user_deviceid = getStore("user_deviceid");
    if (!user_deviceid){
      generateVisitorId().then(result => {
        const deviceid = result;
        setStore("user_deviceid", deviceid);
      })
    }
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
   
    let token = getStore("auth_token");
    let role = getStore('user_role');
    let studentEnable = getStore('user_student_enable');
    let isStudent = isInRole(Vue.prototype.GLOBAL.roleType.student.name);
    if (token) {
      if (isStudent && to.fullPath.indexOf('admin')>0) { //如果是学生且试图访问admin的页面
        next({
          path: from.fullPath,
        });
      }
      else if (isStudent && studentEnable == "0" && to.meta.requireEnable){//如果是已经禁用的学生且试图访问不可用页面
        next({
          path: '/studentDisable',
        });
      }
      else
      next();
    }
    else {
      if (!isStudent || from.fullPath.indexOf('admin')>0) {
        next({
          path: '/admin/',
          //query: { redirect: to.fullPath }  // 将跳转的路由path作为参数，登录成功后跳转到该路由
        });
      } else {
        next({
          path: '/',
          //query: { redirect: to.fullPath }  // 将跳转的路由path作为参数，登录成功后跳转到该路由
        });
      }

    }
  }
  else {
    next();
  }
})




// WEBPACK FOOTER //
// ./src/main.js